"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.nx_setPreferredTarget = exports.nr_setPreferredTarget = exports.nx_setSelection = exports.nr_setSelection = exports.nextSelection = exports.clearSelection = exports.setCursorMode = exports.get = void 0;
var spritesCursors_1 = require("@dive/spriteRecyclers/spritesCursors");
var diveTilemap_sidecar_1 = require("@dive/tilemap/diveTilemap-sidecar");
var distanceUtil_sidecar_1 = require("@lib/distanceUtil-sidecar");
var imports_1 = require("@lib/imports");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var clickEater_sidecar_1 = require("@uiParts/clickEater-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var diveCrew_movable_sidecar_1 = require("@voyage/crew/diveCrew_movable-sidecar");
var diveAi_common_sidecar_1 = require("@dive/ai/diveAi_common-sidecar");
var diveAstar_1 = require("@dive/astar/diveAstar");
var diveColors_1 = require("@dive/colors/diveColors");
var diveDebug_sidecar_1 = require("@dive/debug/diveDebug-sidecar");
var diveObjects_sidecar_1 = require("@dive/entities/diveObjects-sidecar");
var diveSpell_firewall_sidecar_1 = require("@dive/spells/diveSpell_firewall-sidecar");
var diveSpell_lightningCloud_sidecar_1 = require("@dive/spells/diveSpell_lightningCloud-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var voyageGameManager_sidecar_1 = require("@voyage/game-status/voyageGameManager-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var diveMessage_mouseInput_1 = require("@voyage/multi/diveMessage_mouseInput");
var diveMessage_mouseInput_sidecar_1 = require("@voyage/multi/diveMessage_mouseInput-sidecar");
var voyageColors_sidecar_1 = require("@voyage/scene/voyageColors-sidecar");
var voyageSounds_sidecar_1 = require("@voyage/sounds/voyageSounds-sidecar");
var voyagePicker_rect_sidecar_1 = require("@voyage/ui-cursors/voyagePicker_rect-sidecar");
var diveMovementIndicators_sidecar_1 = require("../dive/indicators/diveMovementIndicators-sidecar");
var diveTilemapUtils_sidecar_1 = require("@dive/tilemap/diveTilemapUtils-sidecar");
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
    }
    return _obj;
}
exports.get = get;
function setCursorMode(pickMode) {
    get().pickMode = pickMode;
}
exports.setCursorMode = setCursorMode;
// export function selectFirstCrew() {
//   let cs = diveCrew.getAll()
//   if (cs.length > 0) {
//     get().selectedCrew = cs[0]
//   }
// }
function create() {
    var obj = {
        pickMode: 'normal',
        selectedSpell: null,
        selectedCrew: null,
        preselectedCrew: null,
        hoveredCrew: null,
        // hoveredSystem: null,
        hoveredTile: null,
    };
    return obj;
}
function clearSelection() {
    var obj = get();
    obj.preselectedCrew = null;
    nr_setSelection(null);
}
exports.clearSelection = clearSelection;
// Tab through selections
function nextSelection(dir) {
    var obj = get();
    var crs = diveCrew_sidecar_1.diveCrew.getAll();
    var idxStart = 0;
    if (obj.preselectedCrew) {
        idxStart = imports_1.l.indexOf(crs, obj.preselectedCrew);
    }
    else if (obj.selectedCrew) {
        idxStart = imports_1.l.indexOf(crs, obj.selectedCrew);
    }
    idxStart += dir;
    for (var i = 0; i < crs.length; i++) {
        var idx = mathUtils_sidecar_1.mathUtils.betterMod(idxStart + i * dir, crs.length);
        var cr = crs[idx];
        if (cr.type === diveCrew_1.EVoyageCrewType.Hero && !cr.isDying && !cr.isDead) {
            //} || cr.type === EVoyageCrewType.Alien) {
            nr_setSelection(cr, true);
            return;
        }
    }
}
exports.nextSelection = nextSelection;
function nr_setSelection(cr, centerOn) {
    if (centerOn === void 0) { centerOn = false; }
    var obj = get();
    obj.preselectedCrew = cr; // Immediately show starting selection
    diveMessage_mouseInput_sidecar_1.diveMessage_mouseInput.sendMessageToAll({
        frame: 0,
        hint: diveMessage_mouseInput_1.EDiveInputHint.SelectCrew,
        tx: (cr === null || cr === void 0 ? void 0 : cr.lerp_target_x) || 0,
        ty: (cr === null || cr === void 0 ? void 0 : cr.lerp_target_y) || 0,
        targetId: (cr === null || cr === void 0 ? void 0 : cr.id) || 0,
        fromMultiId: voyageWebsockets_sidecar_1.voyageWebsockets.getMultiId(),
        centerOn: centerOn,
    });
    // TODO: play selection sound?
}
exports.nr_setSelection = nr_setSelection;
function nx_setSelection(msg) {
    var obj = get();
    var target = null;
    if (msg.targetId) {
        target = diveCrew_sidecar_1.diveCrew.findByIdSafe(msg.targetId);
        if (!target) {
            console.warn('target not found', msg);
            return;
        }
    }
    var _a = voyageWebsockets_sidecar_1.voyageWebsockets.isUsEx(msg.fromMultiId), isUs = _a.isUs, from = _a.from;
    if (isUs) {
        // TODO: set the selection to the current player (keep track of all player's selections)
        obj.selectedCrew = target;
        if (obj.preselectedCrew === target) {
            obj.preselectedCrew = null; // Ok, we have selected correctly
        }
    }
    else {
        if (from) {
            from.crewSelected = target;
        }
    }
    // Close ui?
    // voyageUiNav.setOpen(false)
    if (target) {
        if (msg.centerOn && isUs) {
            voyageCamera_sidecar_1.voyageCamera.centerOn(target.x, target.y);
        }
    }
}
exports.nx_setSelection = nx_setSelection;
function nr_setPreferredTarget(cr) {
    var _a;
    var obj = get();
    // obj.preselectedCrew = cr // Immediately show starting selection
    diveMessage_mouseInput_sidecar_1.diveMessage_mouseInput.sendMessageToAll({
        frame: 0,
        hint: diveMessage_mouseInput_1.EDiveInputHint.SetPreferredTarget,
        tx: (cr === null || cr === void 0 ? void 0 : cr.lerp_target_x) || 0,
        ty: (cr === null || cr === void 0 ? void 0 : cr.lerp_target_y) || 0,
        fromCrewId: ((_a = obj.selectedCrew) === null || _a === void 0 ? void 0 : _a.id) || 0,
        targetId: (cr === null || cr === void 0 ? void 0 : cr.id) || 0,
        fromMultiId: voyageWebsockets_sidecar_1.voyageWebsockets.getMultiId(),
        centerOn: false,
    });
}
exports.nr_setPreferredTarget = nr_setPreferredTarget;
function nx_setPreferredTarget(msg) {
    var obj = diveCrew_sidecar_1.diveCrew.findById(msg.fromCrewId);
    if (!obj) {
        websockets_sidecar_1.websockets.reportBadCommand2(msg, 'crew is null');
        return;
    }
    if (msg.targetId <= 0) {
        obj.preferredTarget = null;
    }
    else {
        var target = diveCrew_sidecar_1.diveCrew.findById(msg.targetId);
        if (!target) {
            websockets_sidecar_1.websockets.reportBadCommand2(msg, 'target is null');
            return;
        }
        obj.preferredTarget = target;
        console.log('set preferred target', obj.name, target.name);
    }
}
exports.nx_setPreferredTarget = nx_setPreferredTarget;
function update() {
    var _a, _b, _c, _d, _e;
    var obj = get();
    // Are we on a system?
    if (obj.selectedCrew) {
        if (obj.selectedCrew.tile) {
            // if (obj.selectedCrew.tile.system) {
            //   let sys = obj.selectedCrew.tile.system
            //   if (sys.data.onSelectedCrewOn) {
            //     sys.data.onSelectedCrewOn(obj.selectedCrew)
            //   }
            // }
        }
    }
    if (voyageGameManager_sidecar_1.voyageGameManager.get().mode !== 'game' || clickEater_sidecar_1.clickEater.isCursorEaten()) {
        // Ignore any selection outside of game mode
        return;
    }
    var mij = diveTilemap_sidecar_1.diveTilemap.getIJAtMouse();
    var mxy = diveTilemap_sidecar_1.diveTilemap.convertIJtoXY(mij.i, mij.j);
    var mou = voyageCamera_sidecar_1.voyageCamera.getAdjustedMousePosition();
    var tHere = diveTilemap_sidecar_1.diveTilemap.getSafe(mij.i, mij.j);
    obj.hoveredTile = tHere;
    if (diveDebug_sidecar_1.diveDebug.debug_showCoverShields) {
        var displayShieldsAt = function (i, j) {
            // Display cover shields in each direction for this square
            var tHereShields = diveTilemap_sidecar_1.diveTilemap.getSafe(mij.i, mij.j);
            if (!tHereShields) {
                return;
            }
            if (!diveTilemapUtils_sidecar_1.diveTilemapUtils.isTileWalkable(tHereShields)) {
                return;
            }
            if (!diveTilemapUtils_sidecar_1.diveTilemapUtils.wasSpotVisibleToHero(tHereShields)) {
                return;
            }
            var tryDisplayCoverShield = function (ox, oy, rot) {
                var tShield = diveTilemap_sidecar_1.diveTilemap.getSafe(i + ox, j + oy);
                if (tShield) {
                    var cover_1 = 0;
                    var frame = null;
                    if (!diveTilemapUtils_sidecar_1.diveTilemapUtils.wasSpotVisibleToHero(tShield)) {
                        return;
                    }
                    if (tShield.tile1) {
                        if (tShield.tile1.cover) {
                            cover_1 = tShield.tile1.cover;
                        }
                    }
                    tShield.objects.forEach(function (o) {
                        if (o.data.cover && o.data.cover > cover_1) {
                            cover_1 = o.data.cover;
                        }
                        if (o.data.coverFunc) {
                            var cf = o.data.coverFunc(o);
                            if (cf > cover_1) {
                                cover_1 = cf;
                            }
                        }
                    });
                    // Is there an object here?
                    //let objHeres = tShield.objects
                    //diveObjects.getAtIJ(tShield.i, tShield.j)
                    if (cover_1 === 1) {
                        frame = sprites_sidecar_1.sprites.ufodefenseProtoCoverHalf[0];
                    }
                    if (cover_1 === 2) {
                        frame = sprites_sidecar_1.sprites.ufodefenseProtoCoverFull[0];
                    }
                    if (frame) {
                        var img = spritesCursors_1.spritesCursors.getNext(tShield.x, tShield.y, frame);
                        img.rotation = rot;
                        img.tint = diveColors_1.diveColors.blueGray;
                        img.alpha = 0.75;
                    }
                }
            };
            tryDisplayCoverShield(0, -1, mathUtils_sidecar_1.mathUtils.turn(0));
            tryDisplayCoverShield(0, 1, mathUtils_sidecar_1.mathUtils.turn(0.5));
            tryDisplayCoverShield(-1, 0, mathUtils_sidecar_1.mathUtils.turn(0.75));
            tryDisplayCoverShield(1, 0, mathUtils_sidecar_1.mathUtils.turn(0.25));
            tryDisplayCoverShield(-1, -1, mathUtils_sidecar_1.mathUtils.turn(-0.125));
            tryDisplayCoverShield(1, -1, mathUtils_sidecar_1.mathUtils.turn(0.125));
            tryDisplayCoverShield(1, 1, mathUtils_sidecar_1.mathUtils.turn(-0.125 + 0.5));
            tryDisplayCoverShield(-1, 1, mathUtils_sidecar_1.mathUtils.turn(0.125 + 0.5));
        };
        displayShieldsAt(mij.i, mij.j);
    }
    // Main cursor (hide when rect selecting)
    var isRectSelecting = voyagePicker_rect_sidecar_1.voyagePicker_rect.isRectSelecting();
    if (!isRectSelecting) {
        spritesCursors_1.spritesCursors.getNext(mxy.x, mxy.y, sprites_sidecar_1.sprites.diveEffectsCursorCurrentTile[0]);
    }
    // Don't allow selecting dead crew
    if (obj.preselectedCrew && obj.preselectedCrew.isDead) {
        obj.preselectedCrew = null;
    }
    if (obj.selectedCrew && obj.selectedCrew.isDead) {
        obj.selectedCrew = null;
    }
    if (obj.selectedCrew) {
        spritesCursors_1.spritesCursors.getNext(obj.selectedCrew.x, obj.selectedCrew.y, sprites_sidecar_1.sprites.diveEffectsSelectA[0]);
    }
    if (obj.preselectedCrew) {
        spritesCursors_1.spritesCursors.getNext(obj.preselectedCrew.x, obj.preselectedCrew.y, sprites_sidecar_1.sprites.diveEffectsSelectB[0]);
    }
    if (obj.pickMode === 'cast') {
        if (tHere) {
            var cancel = clickEater_sidecar_1.clickEater.isRightFirstDownAndUneaten();
            if (cancel) {
                obj.pickMode = 'normal';
                obj.selectedSpell = null;
                diveMessage_mouseInput_sidecar_1.diveMessage_mouseInput.sendMessageToAll({
                    hint: diveMessage_mouseInput_1.EDiveInputHint.CancelAbility,
                    centerOn: false,
                    frame: 0,
                    targetId: 0,
                    fromMultiId: voyageWebsockets_sidecar_1.voyageWebsockets.getMultiId(),
                    tx: tHere.i,
                    ty: tHere.j,
                });
                clickEater_sidecar_1.clickEater.tempEat();
                return;
            }
            var spell = obj.selectedSpell;
            if (spell) {
                var activate = clickEater_sidecar_1.clickEater.isLeftFirstDownAndUneaten();
                // Do we have any spell count left?
                var spellCount = 0;
                // TODO: better way of using the weapon for this?
                if (spell === diveSpell_firewall_sidecar_1.diveSpell_firewall) {
                    spellCount = ((_b = (_a = obj.selectedCrew) === null || _a === void 0 ? void 0 : _a.weaponSlot) === null || _b === void 0 ? void 0 : _b.ability1Uses) || 0;
                }
                if (spell === diveSpell_lightningCloud_sidecar_1.diveSpell_lightningCloud) {
                    spellCount = ((_d = (_c = obj.selectedCrew) === null || _c === void 0 ? void 0 : _c.weaponSlot) === null || _d === void 0 ? void 0 : _d.ability2Uses) || 0;
                }
                if (spellCount <= 0) {
                    activate = false;
                    // TODO: What do we show?
                    return;
                }
                // console.log('processing cast mode', tHere.i, tHere.j)
                var _f = diveTilemap_sidecar_1.diveTilemap.convertIJtoXY(tHere.i, tHere.j), cursorTileX = _f.x, cursorTileY = _f.y;
                var cursorOptions = {
                    cursorI: tHere.i,
                    cursorJ: tHere.j,
                    cursorTileX: cursorTileX,
                    cursorTileY: cursorTileY,
                    activate: activate,
                };
                var isValid = spell.spell_cursor(cursorOptions);
                if (isValid && activate && obj.selectedCrew) {
                    clickEater_sidecar_1.clickEater.tempEat();
                    // Stop casting
                    obj.pickMode = 'normal';
                    diveMessage_mouseInput_sidecar_1.diveMessage_mouseInput.sendMessageToAll({
                        hint: diveMessage_mouseInput_1.EDiveInputHint.Cast,
                        centerOn: false,
                        frame: 0,
                        targetId: 0,
                        fromCrewId: obj.selectedCrew.id,
                        fromMultiId: voyageWebsockets_sidecar_1.voyageWebsockets.getMultiId(),
                        tx: tHere.i,
                        ty: tHere.j,
                    });
                    diveMessage_mouseInput_sidecar_1.diveMessage_mouseInput.sendMessageToAll({
                        hint: diveMessage_mouseInput_1.EDiveInputHint.CancelAbility,
                        centerOn: false,
                        frame: 0,
                        targetId: 0,
                        fromMultiId: voyageWebsockets_sidecar_1.voyageWebsockets.getMultiId(),
                        tx: tHere.i,
                        ty: tHere.j,
                    });
                    return;
                }
            }
        }
    }
    if (obj.pickMode === 'normal') {
        // TODO: move to own file / function?
        var closestCrew_1 = null;
        var closestCrewDistance_1 = 20;
        var closestHoverCrew_1 = null;
        var closestTarget_1 = null;
        var closestTargetDistance_1 = 20;
        imports_1.l.forEach(diveCrew_sidecar_1.diveCrew.getAll(), function (c) {
            if (c.isDead || c.isDying) {
                return;
            }
            if (c.isDownStairs) {
                return;
            }
            var dist = distanceUtil_sidecar_1.distanceUtil.distanceNormalXY(mou, c);
            if (dist < closestCrewDistance_1) {
                closestHoverCrew_1 = c;
                if (c.type === diveCrew_1.EVoyageCrewType.Hero && !diveCrew_sidecar_1.diveCrew.isDeadish(c)) {
                    closestCrewDistance_1 = dist;
                    closestCrew_1 = c;
                }
            }
            if (obj.selectedCrew) {
                if (dist < closestTargetDistance_1) {
                    if (c.type === diveCrew_1.EVoyageCrewType.Enemy && !diveCrew_sidecar_1.diveCrew.isDeadish(c)) {
                        if (diveAi_common_sidecar_1.diveAi_common.canSee(obj.selectedCrew, c)) {
                            closestTargetDistance_1 = dist;
                            closestTarget_1 = c;
                        }
                    }
                }
            }
        });
        obj.hoveredCrew = closestCrew_1 || closestHoverCrew_1;
        if (closestTargetDistance_1 < closestCrewDistance_1) {
            obj.hoveredCrew = closestTarget_1;
        }
        if (isRectSelecting) {
            closestHoverCrew_1 = null;
            closestCrew_1 = voyagePicker_rect_sidecar_1.voyagePicker_rect.getSelectedInRect();
        }
        // Show crew we can select
        if (obj.selectedCrew) {
            if (obj.selectedCrew.preferredTarget) {
                if (diveAi_common_sidecar_1.diveAi_common.canSee(obj.selectedCrew, obj.selectedCrew.preferredTarget)) {
                    var imgClosestTarget = spritesCursors_1.spritesCursors.getNext(obj.selectedCrew.preferredTarget.x, obj.selectedCrew.preferredTarget.y, sprites_sidecar_1.sprites.diveEffects2Target[0]);
                    imgClosestTarget.tint = diveColors_1.diveColors.blueGray;
                }
            }
        }
        if (closestTarget_1 &&
            closestTargetDistance_1 < closestCrewDistance_1 &&
            closestTarget_1 !== ((_e = obj.selectedCrew) === null || _e === void 0 ? void 0 : _e.preferredTarget)) {
            var imgClosestTarget = spritesCursors_1.spritesCursors.getNext(closestTarget_1.x, closestTarget_1.y, sprites_sidecar_1.sprites.diveEffects2Target[0]);
            imgClosestTarget.tint = diveColors_1.diveColors.green;
        }
        else {
            if (closestCrew_1 &&
                closestCrew_1 !== obj.selectedCrew &&
                closestCrew_1 !== obj.preselectedCrew) {
                spritesCursors_1.spritesCursors.getNext(closestCrew_1.x, closestCrew_1.y, sprites_sidecar_1.sprites.diveEffectsCursorWillSelect[0]);
            }
        }
        // obj.hoveredSystem = null
        // if (tHere) {
        //   if (tHere.tile3.type === EVoyageTile.System) {
        //     obj.hoveredSystem = tHere
        //   }
        //   if (tHere.tile3.type === EVoyageTile.Elevator) {
        //     obj.hoveredSystem = tHere // 'Elevator ' + tHere.text3
        //   }
        //   if (tHere.tile3.type === EVoyageTile.MedPad) {
        //     obj.hoveredSystem = tHere //'Medical Pad ' + tHere.text3
        //   }
        //   // if (tHere.tile3.type === EVoyageTile.) {
        //   //   obj.hoveredSystem = 'Elevator' + tHere.text3
        //   // }
        // }
        voyagePicker_rect_sidecar_1.voyagePicker_rect.update();
        var trySelectClosestTarget_1 = function () {
            var t = diveTilemap_sidecar_1.diveTilemap.getSafe(mij.i, mij.j);
            if (t) {
                if (closestTarget_1) {
                    nr_setPreferredTarget(closestTarget_1);
                    // TODO
                    voyageSounds_sidecar_1.voyageSounds.playSelected();
                    clickEater_sidecar_1.clickEater.tempEat();
                    return true;
                }
            }
            return false;
        };
        var trySelectClosestCrew = function () {
            if (obj.selectedCrew &&
                closestTarget_1 &&
                closestTargetDistance_1 < closestCrewDistance_1) {
                if (trySelectClosestTarget_1()) {
                    return;
                }
            }
            var t = diveTilemap_sidecar_1.diveTilemap.getSafe(mij.i, mij.j);
            if (t) {
                if (closestCrew_1) {
                    nr_setSelection(closestCrew_1);
                    // TODO
                    voyageSounds_sidecar_1.voyageSounds.playSelected();
                    clickEater_sidecar_1.clickEater.tempEat();
                }
            }
        };
        if (isRectSelecting) {
            // handled in voyagePicker
        }
        else if (clickEater_sidecar_1.clickEater.isLeftFirstDownAndUneaten()) {
            trySelectClosestCrew();
        }
        else if (clickEater_sidecar_1.clickEater.isLeftFirstUpAndUneaten()) {
            //let t = diveTilemap.getSafe(mij.i, mij.j)
            // TODO: only if initial left first down didn't select a crew member
            trySelectClosestCrew();
            // if (t) {
            //   if (closestCrew) {
            //     nr_setSelection(closestCrew)
            //     // setSelection(closestCrew)
            //     voyageSounds.playSelected()
            //     clickEater.tempEat()
            //   } else {
            //     // if (obj.selectedCrew) {
            //     //   // Move
            //     //   voyageCrew_movable.pathTo(obj.selectedCrew, mij.i, mij.j)
            //     // }
            //   }
            // }
        }
        if (!isRectSelecting) {
            if (clickEater_sidecar_1.clickEater.isRightFirstDownAndUneaten()) {
                if (obj.selectedCrew && closestTarget_1) {
                    if (trySelectClosestTarget_1()) {
                        return;
                    }
                }
                // clearSelection()
                // Move
                var t = diveTilemap_sidecar_1.diveTilemap.getSafe(mij.i, mij.j);
                if (t) {
                    if (!closestCrew_1 || closestCrew_1 === obj.selectedCrew) {
                        if (obj.selectedCrew) {
                            var usedAction = false;
                            // Is there an object here?
                            var objHeres = t.objects; // diveObjects.getAllAtIJ(mij.i, mij.j)
                            var objHere = null;
                            if (objHeres.length === 1) {
                                objHere = objHeres[0];
                            }
                            if (objHeres.length > 1) {
                                // Find best object
                                objHere =
                                    objHeres.filter(function (c) { return c.data.canBePickedUp; })[0] || objHeres[0];
                            }
                            // console.log('objHeres', objHeres.length, objHere)
                            if (objHere) {
                                if (!diveObjects_sidecar_1.diveObjects.isWalkable(objHere)) {
                                    usedAction = true;
                                    if (objHere.data.smashInto) {
                                        // Send a command to smash this
                                        usedAction = true;
                                        if (diveCrew_movable_sidecar_1.diveCrew_movable.tryPathTo_testOnly(obj.selectedCrew, t.i, t.j, diveAstar_1.EDivePathToMode.NextTo)) {
                                            diveMessage_mouseInput_sidecar_1.diveMessage_mouseInput.sendMessageToAll({
                                                centerOn: false,
                                                frame: 0,
                                                fromMultiId: voyageWebsockets_sidecar_1.voyageWebsockets.getMultiId(),
                                                targetId: obj.selectedCrew.id,
                                                tx: t.i,
                                                ty: t.j,
                                                hint: diveMessage_mouseInput_1.EDiveInputHint.Smash,
                                            });
                                        }
                                    }
                                    else if (objHere.data.canOpen && !objHere.isOpen) {
                                        // Send a command to open this
                                        usedAction = true;
                                        // console.log('try move next to object')
                                        if (diveCrew_movable_sidecar_1.diveCrew_movable.tryPathTo_testOnly(obj.selectedCrew, t.i, t.j, diveAstar_1.EDivePathToMode.NextTo)) {
                                            // console.log('try move next to success')
                                            diveMessage_mouseInput_sidecar_1.diveMessage_mouseInput.sendMessageToAll({
                                                centerOn: false,
                                                frame: 0,
                                                fromMultiId: voyageWebsockets_sidecar_1.voyageWebsockets.getMultiId(),
                                                targetId: obj.selectedCrew.id,
                                                tx: t.i,
                                                ty: t.j,
                                                hint: diveMessage_mouseInput_1.EDiveInputHint.Open,
                                            });
                                        }
                                    }
                                }
                                else {
                                    if (objHere.data.canBePickedUp) {
                                        // Send a command to smash this
                                        usedAction = true;
                                        if (diveCrew_movable_sidecar_1.diveCrew_movable.tryPathTo_testOnly(obj.selectedCrew, t.i, t.j, diveAstar_1.EDivePathToMode.On)) {
                                            console.log('trying pickup!');
                                            diveMessage_mouseInput_sidecar_1.diveMessage_mouseInput.sendMessageToAll({
                                                centerOn: false,
                                                frame: 0,
                                                fromMultiId: voyageWebsockets_sidecar_1.voyageWebsockets.getMultiId(),
                                                targetId: objHere.id,
                                                fromCrewId: obj.selectedCrew.id,
                                                tx: t.i,
                                                ty: t.j,
                                                hint: diveMessage_mouseInput_1.EDiveInputHint.PickUp,
                                            });
                                        }
                                    }
                                }
                            }
                            if (distanceUtil_sidecar_1.distanceUtil.isAtIJ(obj.selectedCrew, mij)) {
                                usedAction = true;
                                console.log('click on selected!');
                                // Drop / pickup
                                // voyageSystems_rack.swapItemHere(obj.selectedCrew, true)
                                // let droppable = diveCrew.getFirstDroppableItem(obj.selectedCrew)
                                // let pickupable = t.items[0] || null
                                // if (droppable || pickupable) {
                                //   if (voyageWebsockets.getIsHost()) {
                                //     if (droppable && pickupable) {
                                //       voyageMessageCrewCarry.sendMessageAndImmediatelyExecute({
                                //         command: EVoyageCrewCarryCommand.Swap,
                                //         type: droppable.type,
                                //         carryId1: droppable.id,
                                //         carryId2: pickupable.id,
                                //         crewId: obj.selectedCrew.id,
                                //         i: mij.i,
                                //         j: mij.j,
                                //       })
                                //     } else if (droppable) {
                                //       voyageMessageCrewCarry.sendMessageAndImmediatelyExecute({
                                //         command: EVoyageCrewCarryCommand.Drop,
                                //         type: droppable.type,
                                //         carryId1: droppable.id,
                                //         carryId2: 0,
                                //         crewId: obj.selectedCrew.id,
                                //         i: mij.i,
                                //         j: mij.j,
                                //       })
                                //     } else if (pickupable) {
                                //       voyageMessageCrewCarry.sendMessageAndImmediatelyExecute({
                                //         command: EVoyageCrewCarryCommand.Pickup,
                                //         type: pickupable.type,
                                //         carryId1: pickupable.id,
                                //         carryId2: 0,
                                //         crewId: obj.selectedCrew.id,
                                //         i: mij.i,
                                //         j: mij.j,
                                //       })
                                //     }
                                //   }
                                // }
                            }
                            if (!usedAction) {
                                // Move here
                                if (diveCrew_movable_sidecar_1.diveCrew_movable.nr_tryPathTo(obj.selectedCrew, mij.i, mij.j, diveAstar_1.EDivePathToMode.OnOrNextTo_PreferOn)) {
                                    var mi = diveMovementIndicators_sidecar_1.diveMovementIndicators.create(voyageColors_sidecar_1.voyageColors.yellow);
                                    diveMovementIndicators_sidecar_1.diveMovementIndicators.moveToIJ(mi, mij);
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
exports.update = update;
